import React from "react";
import ReactDom from "react-dom";
import classes from "./BackgroundOverlay.module.css";

const BackgroundOverlay = ({ defaultZIndex = 10 }) => {
  return ReactDom.createPortal(
    <div className={classes["background"]} style={{ zIndex: defaultZIndex }} />,
    document.getElementById("background-overlay")
  );
};
export default BackgroundOverlay;
